import { render, staticRenderFns } from "./ListCollaborator.vue?vue&type=template&id=80693ce0&scoped=true&"
import script from "./ListCollaborator.vue?vue&type=script&lang=js&"
export * from "./ListCollaborator.vue?vue&type=script&lang=js&"
import style0 from "./ListCollaborator.vue?vue&type=style&index=0&id=80693ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80693ce0",
  null
  
)

export default component.exports